export enum CollabSessionError {
  DocLoadFailed = 'Doc Load Failed',
  DocReadOnly = 'Doc Read-Only',
  DocRevertFailed = 'Doc Revert Failed',
  DocSizeTooLarge = 'Doc Size Too Large',
  DocUpdatesLoadFailed = 'Doc Updates Load Failed',
  DocUpdateFailed = 'Doc Update Failed',
  DocUserUpdateFailed = 'Doc User Update Failed',
  DocVersionInvalid = 'Doc Version Invalid',
  MetaDataNotReady = 'Meta Data Not Ready',
  MongoDBDocumentSizeTooLarge = 'MongoDB Document Size Too Large',
  ReviewFileLoadFailed = 'Review File Load Failed',
  SchemaVersionIncompatible = 'Schema Version Incompatible',
  ThrottledSendChangesFailed = 'Throttled Send Changes Failed',
  ThrottledSendUserDataFailed = 'Throttled Send User Data Failed',
  VersionMismatch = 'Version Mismatch',
  VersionTooOld = 'Version Too Old'
}
